import React from "react";
import "../Partner/partner.scss";
import AdminFirst from "../../Assets/Images/admin-graph.png";
import Woo from "../../Assets/Images/woo-commerce.png";
import Shopify from "../../Assets/Images/shopify.png";
import Magento from "../../Assets/Images/magento.png";

const Partner = () => {
  return (
    <div className="partner-main">
      <div className="common-banner">
        <div className="container">
          <div className="common-head">
            <div className="line-head">
              <p>Work with us</p>
            </div>
            <h1>Become A Partner</h1>
          </div>
          <p className="text-center">
            Join the likes of leading eCommerce vendors and merchants with
            In-Transit, an efficient way of package tracking combined with
            premium order protection
          </p>
        </div>
      </div>

      <div className="partner-desc">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              {/* <h5 className="sub-heading">Loren ipsum sit</h5> */}
              <p>
                Upgrade your eCommerce deliveries with InTransit’s efficient and
                secure post-purchase tracking service. Give your customers and
                prospects the assurance of secure online deliveries with
                Intransit’s Geo-fencing based Live Tracking and premium order
                protection services.
              </p>
              <p>
                Bump off the hassle relate to the hectic shipping and
                deliveries. Customers can directly deal with InTransit in case
                of any issues with the protected orders/items.
              </p>
            </div>
            <div className="col-md-6">
              <div className="show-img-admin">
                <img src={AdminFirst} alt="admin"/>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="partner-form">
        <div className="container">
          <h5 className="sub-heading text-center mb-4">reach out to us</h5>
          <form>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>First Name</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Last Name</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Your Email</label>
                  <input type="email" className="form-control" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Website URL</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
            </div>
            <div className="text-center mt-4">
              <button className="yellow-btn">Send Message</button>
            </div>
          </form>
        </div>
      </div>

      <div className="partner-logo">
        <div className="container">
          <h5 className="sub-heading text-center">reach out to us</h5>
          <ul>
            <li>
              <div className="partner-logo-img">
                <img src={Shopify} alt="Shopify" />
              </div>
            </li>
            <li>
              <div className="partner-logo-img">
                <img src={Woo} alt="Woo"/>
              </div>
            </li>
            <li>
              <div className="partner-logo-img">
                <img src={Magento} alt="Magento"/>
              </div>
            </li>
            <li>
              <div className="partner-logo-img">
                <img src={Shopify} alt="Shopify" />
              </div>
            </li>
            <li>
              <div className="partner-logo-img">
                <img src={Woo} alt="Woo"/>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Partner;
